import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDocumentApprovedSmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        width={38.1}
        height={47.1}
        x={10.95}
        y={6.52}
        stroke="url(#document_approved_small_svg__a)"
        strokeWidth={5.01}
        rx={6.69}
      />
      <path stroke="#0D2B57" strokeWidth={0.5} d="M19.48 17.3h21.05m-21.05 5.01h21.05" />
      <rect width={19.55} height={19.55} x={35.59} y={33.92} fill="#0D2B57" rx={9.78} />
      <rect
        width={19.55}
        height={19.55}
        x={35.59}
        y={33.92}
        stroke="#fff"
        strokeWidth={0.5}
        rx={9.78}
      />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.5}
        d="m41.56 44.19 1.76 1.88 4.09-5.01"
      />
      <defs>
        <linearGradient
          id="document_approved_small_svg__a"
          x1={30}
          x2={30}
          y1={6.52}
          y2={53.65}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentApprovedSmall);
export default ForwardRef;
